import React, { useEffect, useState } from "react";
import config from "../../config.json";
import { v4 as uuidv4 } from "uuid";
import WorkflowElement from "../../app/components/WorkflowElement";
import { useDispatch, useSelector } from "react-redux";
import { getAppDefaultData, getStartedAppData, loadAppDefaultData, startNewApplication } from "../../app/store/application";
import { getAlert, getConfirmAlert } from "../../services/appAlerts";
import {
  addNewSubcontractor, addNewSubcontractorUser, checkSubcontractorEmail, checkSubcontractorUsrEmail, checkSubcontractorUsrMobile,
  getCheckSubEmailStatus, getCheckSubUsrEmailStatus, getCheckSubUsrMobileStatus,
  getNewSubcontractorId, getNewSubcontractorUser, getSubcontractorBprmForm,
  loadSubcontractorBprmForm, sendMailToSubcontrator, subcontractorUserRefresh, subcontractorUserStatus,
  subcontractorUserid
} from "../../app/store/subcontractor";
import { currentWfTaskReceived, getCurrentWorkflowTask, loadCurrentWorkflowTask } from "../../app/store/WorkflowEngine";
import { addFormLibrary } from "../../app/store/forms";
import { getCurrentUser } from "../../app/store/auth";
import { updateBprmForm } from "../../app/store/bprmForm";
import _ from "lodash";
import { loadSubcontractorPartners, subcontractorPartnersRecevied } from "../../app/store/partner";

const AddSubcontractor = (props) => {
  const { selectedObj, handleAddEditSubcontractor, selectedTab, showHideSub } = props;

  const [wfTask, setWfTask] = useState(null);
  const [appDefaultData, setAppDefaultData] = useState("");
  const [aWorkfinityApp, setAworkfinityApp] = useState("");
  const [appId, setAppId] = useState(1);
  const [stateData, setStateData] = useState(null);
  const [updatedStateData, setUpdatedStateData] = useState(null);
  const [updatedStateData2, setUpdatedStateData2] = useState(null);
  const [uuid, setUuid] = useState("");
  const [subContactName, setSubContactName] = useState("");
  const [reqCount, setReqCount] = useState(0);
  const [wfId, setWfId] = useState(config.workflowsIds.subcontractor);
  const [saveBtnProcessStatus, setSaveBtnProcessStatus] = useState(false);
  const [newAddedSubcontractor, setNewAddedSubcontractor] = useState(false);
  const [wfForm, setWfForm] = useState(null);
  const [saveBtnType, setSaveBtnType] = useState("");
  const [addedParterId, setAddedParterId] = useState(0);
  const [addedParterUserId, setAddedParterUserId] = useState(0);

  const appDefaultDataSelector = useSelector(getAppDefaultData);
  const newSubcontractorIdSelector = useSelector(getNewSubcontractorId);
  const newSubcontractorUserSelector = useSelector(getNewSubcontractorUser);
  const appStartedDataSelector = useSelector(getStartedAppData);
  const currentWorkflowTaskSelector = useSelector(getCurrentWorkflowTask);
  const checkSubEmailStatusSelector = useSelector(getCheckSubEmailStatus);
  const checkSubUsrEmailStatusSelector = useSelector(getCheckSubUsrEmailStatus);
  const checkSubUsrMobileStatusSelector = useSelector(getCheckSubUsrMobileStatus);
  const subcontractorBprmFormSelector = useSelector(getSubcontractorBprmForm);
  //const filterAllSubcontractors = useSelector(getFilterAllSubcontractors)

  const currentUser = getCurrentUser();
  const dispatch = useDispatch();

  useEffect(() => {
    if (selectedTab === "addEditSubcontractor")
      dispatch(loadAppDefaultData(1))
  }, []);

  // useEffect(() => {
  //   if (filterAllSubcontractors.length > 0) {
  //     setDupliEntry(filterAllSubcontractors[0])
  //     setSaveBtnProcessStatus(false)
  //   }
  // }, [filterAllSubcontractors])

  useEffect(() => {
    if (selectedTab === "addEditSubcontractor") {
      let appCiid = 0;
      if (selectedObj?.applications?.length > 0) {
        const allWfTasks = selectedObj?.applications[0].workflowTasks;
        if (allWfTasks?.length > 0) {
          appCiid = allWfTasks[allWfTasks.length - 1].ciid;
        }
      }
      setWfTask({ formId: config.formIds.subcontractor, ciid: appCiid });
      dispatch(loadSubcontractorBprmForm(config.formIds.subcontractor))
      if (selectedObj?.contact1) {
        setUpdatedStateData(selectedObj.contact1.performerData);
      }
      else {
        setUpdatedStateData(null);
        setStateData(null);
      }
      setSaveBtnProcessStatus(false)
    }
  }, [selectedObj, selectedTab]);

  // useEffect(() => {
  //   if (dupliEntry?.contact1) {
  //     setUpdatedStateData2(dupliEntry.contact1.performerData)
  //   }
  //   else {
  //     setUpdatedStateData2(null);
  //   }
  // }, [dupliEntry]);

  // useEffect(() => {
  //   let appCiid = 0;
  //   if (dupliEntry?.applications?.length > 0) {
  //     const allWfTasks = dupliEntry?.applications[0]?.workflowTasks;
  //     if (allWfTasks?.length > 0) {
  //       appCiid = allWfTasks[allWfTasks.length - 1].ciid;
  //     }
  //     setWfTask({ formId: config.formIds.subcontractor, ciid: appCiid });
  //     setSaveBtnProcessStatus(false)
  //   }
  // }, [dupliEntry]);

  useEffect(() => {
    if (subcontractorBprmFormSelector) setWfForm(subcontractorBprmFormSelector);
  }, [subcontractorBprmFormSelector])


  useEffect(() => {
    if (appDefaultDataSelector !== "") {
      setAppDefaultData(appDefaultDataSelector);
    }
  }, [appDefaultDataSelector]);

  const handleSubmit = async (stData) => {
    const aWorkfinityApp = { ...appDefaultData };
    const appShortName = Object.keys(aWorkfinityApp)[1];
    let aWorkfinityAppEntity = { ...aWorkfinityApp[appShortName] };

    let subcontractorenrollment = {};
    const data = {};
    Object.keys(stData).forEach(function (keyValue) {
      const dd = keyValue.split(".");
      if (dd.length > 1) {
        if (dd[1] !== "undefined" && aWorkfinityAppEntity !== undefined)
          subcontractorenrollment["@" + dd[1]] = stData[keyValue];
        data[dd[1]] = stData[keyValue];
      }
    });

    const guid = uuidv4();
    // subcontractorenrollment["EntityId"] = guid;

    // data["EntityId"] = guid;

    const jhgf = JSON.parse(updatedStateData);
    const entiyId = jhgf?.HROCCMSAppEntity?.subcontractorenrollmentform?.EntityId;

    if (!selectedObj) {
      if (addedParterUserId <= 0) {
        subcontractorenrollment["EntityId"] = guid;
        data["EntityId"] = guid;
      } else {
        const jhgfss = JSON.parse(updatedStateData2);
        const entiyId2 = jhgfss?.HROCCMSAppEntity?.subcontractorenrollmentform?.EntityId;
        subcontractorenrollment["EntityId"] = entiyId2;
        data["EntityId"] = entiyId2;
      }
    } else {
      subcontractorenrollment["EntityId"] = entiyId;
      data["EntityId"] = entiyId;
    }

    const usrDdtype = "subcontractorenrollmentform";
    aWorkfinityAppEntity[usrDdtype] = subcontractorenrollment;
    aWorkfinityApp[appShortName] = aWorkfinityAppEntity;

    let contactName = data["Key_Contact1_First_Name"];
    if (
      !data["Key_Contact1_Middle_Name"] &&
      data["Key_Contact1_Middle_Name"] !== ""
    )
      contactName += " " + data["Key_Contact1_Middle_Name"];
    if (!data["Key_Contact1_Last_Name"])
      contactName += " " + data["Key_Contact1_Last_Name"];

    setStateData(data);
    setUuid(guid)
    setSubContactName(contactName);
    setAppDefaultData(aWorkfinityApp);
    setAworkfinityApp(aWorkfinityApp)

    if (!selectedObj) {
      if (addedParterId <= 0) {
        const partEmail = data["Company_Email"];
        const keyEmail = data["Key_Contact1_Email"];
        const keyMobile = data["Key_Contact1_Mobile"];
        if (partEmail && partEmail !== "") {
          dispatch(checkSubcontractorEmail(partEmail, "Sub-Contractors"));
        } else if (keyEmail && keyEmail !== "") {
          dispatch(checkSubcontractorUsrEmail(keyEmail, "Sub-Contractors"));
        } else if (keyMobile && keyMobile !== "") {
          dispatch(checkSubcontractorUsrMobile(keyMobile, "Sub-Contractors"));
        } else {
          saveSubcontractor(data);
        }
      } else {
        saveSubcontractor(data);
      }
    }
    else {
      saveSubcontractor(data);
    }
  }

  useEffect(() => {
    const keyEmail = stateData ? stateData["Key_Contact1_Email"] : "";
    const keyMobile = stateData ? stateData["Key_Contact1_Mobile"] : "";

    if (checkSubEmailStatusSelector) {
      async function userConfirmation() {
        const rs = await getConfirmAlert("Warning", "Subcontractor Email already exist. Do you want Add duplicate Email Address?", "warning");
        if (rs.isConfirmed) {
          if (keyEmail && keyEmail !== "") {
            dispatch(checkSubcontractorUsrEmail(keyEmail));
          } else if (keyMobile && keyMobile !== "") {
            dispatch(checkSubcontractorUsrMobile(keyMobile));
          }
          else {
            saveSubcontractor();
          }
        } else {
          setSaveBtnProcessStatus(false);
          dispatch(subcontractorUserRefresh())
        }
      }
      userConfirmation();
    }
    else if (checkSubEmailStatusSelector === false) {
      if (keyEmail && keyEmail !== "") {
        dispatch(checkSubcontractorUsrEmail(keyEmail));
      } else if (keyMobile && keyMobile !== "") {
        dispatch(checkSubcontractorUsrMobile(keyMobile));
      }
      else {
        saveSubcontractor(stateData);
      }
    }
  }, [checkSubEmailStatusSelector]);

  useEffect(() => {
    const keyMobile = stateData ? stateData["Key_Contact1_Mobile"] : "";
    if (checkSubUsrEmailStatusSelector) {
      async function userConfirmation() {
        const rs = await getConfirmAlert("Warning", "Subcontractor key contact Email alreday exist. Do you want Add duplicate Email Address?", "warning");
        if (rs.isConfirmed) {
          if (keyMobile && keyMobile !== "") {
            dispatch(checkSubcontractorUsrMobile(keyMobile))
          }
          else {
            saveSubcontractor(stateData);
          }
        } else {
          setSaveBtnProcessStatus(false);
          dispatch(subcontractorUserRefresh())
        }
      }
      userConfirmation();
    }
    else if (checkSubUsrEmailStatusSelector === false) {
      if (keyMobile && keyMobile !== "") {
        dispatch(checkSubcontractorUsrMobile(keyMobile));
      }
      else {
        saveSubcontractor(stateData);
      }
    }
  }, [checkSubUsrEmailStatusSelector]);

  useEffect(() => {
    if (checkSubUsrMobileStatusSelector) {
      async function userConfirmation() {
        const rs = await getConfirmAlert("Warning", "Subcontractor key contact Mobile Number alreday exist. Do you want Add duplicate Mobile Number?", "warning");
        if (rs.isConfirmed) {
          saveSubcontractor(stateData);
        } else {
          setSaveBtnProcessStatus(false);
          dispatch(subcontractorUserRefresh())
        }
      }
      userConfirmation();
    }
    else if (checkSubUsrMobileStatusSelector === false) {
      saveSubcontractor(stateData);
    }
  }, [checkSubUsrMobileStatusSelector]);

  const updateBprmFormData = async (aWorkfinityApp) => {
    const disValus = _.uniq(["subcontractorenrollmentform"]);
    const frmData = new FormData();
    frmData.append("appEntity", JSON.stringify(aWorkfinityApp));
    frmData.append("ciid", wfTask.ciid);
    frmData.append("ddTypes", disValus);
    frmData.append("formId", wfTask.formId);
    frmData.append("performerId", currentUser.id);
    frmData.append("userName", currentUser.name);
    dispatch(updateBprmForm(frmData));
  };

  const saveSubcontractor = async (data) => {
    let fuid = 0;
    if (selectedObj?.fuid) {
      fuid = selectedObj.fuid;
    }
    else if (addedParterId > 0) {
      fuid = addedParterId;
    }

    const partnerObj = {
      fuid: fuid,
      label: data["Company_Name"],
      state: data["Company_State"],
      city: data["Company_City"],
      zip: data["Company_Zip_Code"],
      partnerType: "Sub-Contractors",
      contactName: subContactName,
      entryStartNumber: 1,
      entryEndNumber: 100,
      totalEntryRecords: 100,
      email: data["Company_Email"],
      accessKey: data["Company_Address_Line1"],
      portalUrl: data["Company_Address_Line2"],
      appId: appId,
    };
    dispatch(addNewSubcontractor(partnerObj));
  }

  const saveSubcontractorUser = (partId) => {
    const data = { ...stateData };
    let regId = 0;
    if (selectedObj?.id) {
      regId = selectedObj?.id;
    } else if (addedParterUserId > 0) {
      regId = addedParterUserId;
    }

    let performerId;
    if (selectedObj?.contact1?.performerid)
      performerId = selectedObj?.contact1?.performerid

    const reg = {
      id: regId,
      first_Name: data["Key_Contact1_First_Name"],
      middle_Name: !data["Key_Contact1_Middle_Name"] ? "" : data["Key_Contact1_Middle_Name"],
      last_Name: data["Key_Contact1_Last_Name"],
      email: data["Key_Contact1_Email"],
      mobile: data["Key_Contact1_Mobile"],
      workflowId: wfId,
      entityId: uuid,
      type: "subcontractor",
      address_Line1: data["Company_Address_Line1"],
      address_Line2: data["Company_Address_Line2"],
      us_State: data["Company_State"],
      us_County: data["Company_Country"],
      us_City: data["Company_City"],
      zip_Code: data["Company_Zip_Code"],
      title: data["Key_Contact1_Title"],
      isTeamLead: true,
      partnerId: partId,
    };
    const aWorkfinityApp = { ...appDefaultData };
    const formData = new FormData();
    formData.append("appEntity", JSON.stringify(aWorkfinityApp));
    formData.append("registration", JSON.stringify(reg));
    dispatch(addNewSubcontractorUser(formData));
    setSaveBtnProcessStatus(true);
  }

  useEffect(() => {
    if (newSubcontractorIdSelector > 0) {
      saveSubcontractorUser(newSubcontractorIdSelector);
      if (addedParterId === 0 && !selectedObj) {
        dispatch(sendMailToSubcontrator(newSubcontractorIdSelector))
      }
      setAddedParterId(newSubcontractorIdSelector);
    }
  }, [newSubcontractorIdSelector]);

  useEffect(() => {
    if (newSubcontractorUserSelector) {
      let regId = 0;
      if (selectedObj?.id) {
        regId = selectedObj?.id;
      } else if (addedParterUserId > 0) {
        regId = addedParterUserId;
      }
      if (regId > 0) {
        getAlert("", "Updated Successfully", "success");
        setNewAddedSubcontractor(true);
        if (wfTask.ciid > 0)
          updateBprmFormData(aWorkfinityApp);
        if (saveBtnType === "saveAndContinue") {
          setTimeout(() => {
            setSaveBtnProcessStatus(false);
            handleAddEditSubcontractor("exit");
          }, 2000);
        }
        else {
          setSaveBtnProcessStatus(false);
        }
      } else {
        getAlert("", "Added Successfully", "success");
        if (saveBtnType === "saveAndContinue") {
          setTimeout(() => {
            setSaveBtnProcessStatus(false);
            handleAddEditSubcontractor("exit");
          }, 2000);
        }
        else {
          setSaveBtnProcessStatus(false);
        }
        dispatch(subcontractorPartnersRecevied([]));
        dispatch(loadSubcontractorPartners("Sub-Contractors"));
        setAddedParterUserId(newSubcontractorUserSelector.performerid);
        handleRunApplication(newSubcontractorUserSelector);
      }
      dispatch(subcontractorUserStatus())
      dispatch(subcontractorUserid())
    }
  }, [newSubcontractorUserSelector]);

  const handleRunApplication = async (userObj) => {
    const newApplication = {
      workflowId: userObj.workflowId,
      performerId: parseInt(userObj.performerid),
      applicationId: userObj.applicationId,
    };
    dispatch(startNewApplication(newApplication));
    setNewAddedSubcontractor(true);
    // if (saveBtnType === "saveAndContinue")
    //   handleAddEditSubcontractor("exit");
  };

  useEffect(() => {
    if (appStartedDataSelector?.ciid > 0 && newAddedSubcontractor) {
      setTimeout(async () => {
        dispatch(loadCurrentWorkflowTask(appStartedDataSelector));
        setReqCount(1);
      }, 3000);
    }
  }, [appStartedDataSelector]);

  useEffect(() => {
    if (currentWorkflowTaskSelector?.formId === null && reqCount <= 2 && newAddedSubcontractor) {
      setTimeout(async () => {
        dispatch(loadCurrentWorkflowTask(appStartedDataSelector));
        const rqCount = reqCount + 1;
        setReqCount(rqCount);
      }, 3000);
    }
    else if (currentWorkflowTaskSelector?.wiid > 0 && newAddedSubcontractor) {
      setNewAddedSubcontractor(false);
      dispatch(currentWfTaskReceived(""));
      setWfTask(currentWorkflowTaskSelector);
    }
  }, [currentWorkflowTaskSelector]);

  const addReqFormLibrary = async (currentTask, frmObj) => {
    let workflowTask = { ...currentTask };
    workflowTask["ApplicantId"] = workflowTask.performerId;
    workflowTask["performerId"] = currentUser.id;
    const frmData = new FormData();
    frmData.append("workflowTask", JSON.stringify(workflowTask));
    frmData.append("formId", frmObj.formId);
    frmData.append("formName", frmObj.formName);
    frmData.append("remarks", frmObj.remarks);
    frmData.append("id", "");
    frmData.append("formType", frmObj.formType);
    frmData.append("status", "1");
    dispatch(addFormLibrary(frmData));
  };

  const handleNextTask = (data, btn) => {
    if (data)
      handleSubmit(data);
    if (btn) setSaveBtnType(btn)
  }

  return (
    <div className="col-md-12">
      <div className="row">

        {wfForm && <WorkflowElement
          wfTask={wfTask}
          wfForm={wfForm}
          handleNextTask={handleNextTask}
          viewType={false}
          appSummary={false}
          codeVerified={selectedObj?.contact1?.performerid ? false : true}
          wfTaskType={"form"}
          actionType={"workflow"}
          saveBtnProcessStatus={saveBtnProcessStatus}
          setSaveBtnProcessStatus={setSaveBtnProcessStatus}
          updatedStateData={updatedStateData}
        />}

        <div className="col-md-12 text-center">
          {/* <Button
            variant="primary"
            disabled={btnProcess}
            onClick={this.doSubmit}
          >
            {btnProcess && (
              <i className="fa fa-circle-o-notch fa-spin mr-1"></i>
            )}
            Save
          </Button> */}
        </div>
      </div>
    </div>
  );
}

export default AddSubcontractor;
